import { Box, Calendar, DataTable, Text } from "grommet";
import React, { useCallback, useEffect, useState } from "react";
import MedicalEmergencyService from "../../../../../../services/medical-emergency/medical-emergency.service";
import { MedicalEmergencyStatus } from "../../../../../../services/medical-emergency/typings/IMedicalEmergencyApiResponse";
import { MedicalEmergencyWithPassengerType } from "../../../../../../services/medical-emergency/typings/MedicalEmergencyWithPassengerType";
import { GenderEnum } from "../../../../../../services/passenger/typings/PassengerType";
import StandardColors from "../../../../../../util/StandardColors";
import { useUser } from "../../../../context/User/UserContext";
import MedicalEmergencyTable from "../common/MedicalEmergencyTable/MedicalEmergencyTable";
import YearSelection from "../common/YearSelection/YearSelection";
import "./MedicalEmergencyHistory.css";
import { useStore } from "../../../../../../Hooks/useStore";
import { observer } from "mobx-react";
import { Mixpanel } from "../../../../../../util/Helper";
import searchLogo from "../../../../../../assets/search.svg";
import CommonSearchInput from "../../../common/SearchInput/CommonSearchInput";
import CommonButton from "../../../common/Button/CommonButton";
import { includes } from "lodash";
import ReportModal from "./ReportModal";
import ImageViewer from "react-simple-image-viewer";
import Pagination from "../../../common/Pagination/Pagination";

const MedicalEmergencyHistory = observer(() => {
  const { rootStore } = useStore();
  const [searchString, setSearchString] = useState("");
  const [list, setList] = useState([] as MedicalEmergencyWithPassengerType[]);
  // const [selectedDate, setSelectedDate] = useState(new Date().toISOString());
  // const [yearSelected, setYearSelected] = useState(
  //   new Date().getFullYear().toString()
  // );

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);


  const { user } = useUser();

  // const [
  //   medicalEmergencyWithPassengerList,
  //   setMedicalEmergencyWithPassengerList,
  // ] = useState([] as MedicalEmergencyWithPassengerType[]);

  const onYearSelected = useCallback((year: string) => {
    Mixpanel.track("web_medical_history_year_select",{name: user?.username});
    rootStore.emsStore.setYearSelected(year);
    rootStore.emsStore.handleYearSelectionShow();
  }, []);

  const onMonthSelected = useCallback((month: string) => {
    Mixpanel.track("web_medical_history_month_select",{name: user?.username});
    rootStore.emsStore.setMonthSelected(month);
    rootStore.emsStore.handleYearSelectionShow();
  }, []);

  // Trigger on selected year change //
  useEffect(() => {
    const date = new Date(Date.parse(rootStore.emsStore.getSelectedDate));
    date.setFullYear(Number.parseInt(rootStore.emsStore.getSelectedYear));
    date.setMonth(Number.parseInt(rootStore.emsStore.getSelectedMonth));
    rootStore.emsStore.setSelectedDate(date.toISOString());

    
    return () => {
      rootStore.emsStore.resetDateSelect();
    }
  }, [rootStore.emsStore.getSelectedYear, rootStore.emsStore.getSelectedMonth]);

  useEffect(() => {
    rootStore.loadingStore.setShowLoader(true);
    (async () => {
      if (user) {
        rootStore.emsStore.handleMedicalListWithPassengername(user?.username);
      }
      rootStore.loadingStore.setShowLoader(false);
    })().catch((e) => rootStore.loadingStore.setShowLoader(false));
  }, [user]);

  const defaultMedicalList = () => {
    if (rootStore.emsStore.getIsDateSelected) {
      const filteredMedicalEmergenciesWithPassenger =
        rootStore.emsStore.medicalEmergencyWithPassengerList.filter((item) => {
          const selectedDateMs = new Date(
            Date.parse(rootStore.emsStore.getSelectedDate)
          );
          const medicalEmergencyDateMs = new Date(Date.parse(item.timestamp));
          selectedDateMs.setHours(0, 0, 0, 0);
          medicalEmergencyDateMs.setHours(0, 0, 0, 0);
          return selectedDateMs.getTime() === medicalEmergencyDateMs.getTime();
        });
        setList(filteredMedicalEmergenciesWithPassenger);
    } else {
      setList(rootStore.emsStore.medicalEmergencyWithPassengerList);
    }
  }

  useEffect(() => {
    defaultMedicalList();
  },[rootStore.emsStore.getSelectedDate, rootStore.emsStore.medicalEmergencyWithPassengerList, rootStore.emsStore.getHistoryReportList]);

  useEffect(() => {
    return () => {
      rootStore.emsStore.resetReportModal();
    }
  },[]);
  const handleTextClick = () => {
    rootStore.emsStore.handleYearSelectionShow();
  }

  useEffect(() => {
    const textElement = document.querySelector('.calendar-customize h3');
    if (textElement) {
      textElement.addEventListener('click', handleTextClick);
    }

    return () => {
      const textElement = document.querySelector('.calendar-customize h3');
      if (textElement) {
        textElement.addEventListener('click', handleTextClick);
      }
    }
  },[]);

  const resetList = () => {
    if (rootStore.emsStore.getIsDateSelected) {
      let filteredMedicalEmergenciesWithPassenger =
      rootStore.emsStore.medicalEmergencyWithPassengerList.filter((item) => {
        const selectedDateMs = new Date(
          Date.parse(rootStore.emsStore.getSelectedDate)
        );
        const medicalEmergencyDateMs = new Date(Date.parse(item.timestamp));
        selectedDateMs.setHours(0, 0, 0, 0);
        medicalEmergencyDateMs.setHours(0, 0, 0, 0);
        return selectedDateMs.getTime() === medicalEmergencyDateMs.getTime();
      });
      setList(filteredMedicalEmergenciesWithPassenger)
    } else {
      setList(rootStore.emsStore.medicalEmergencyWithPassengerList)
    }
  }

  const onSearchStrChange = (searchString: string) => {
    setSearchString(searchString);
    if (searchString == "") {
      resetList();
    }
  }

const closeImage = () => {
  rootStore.emsStore.handleHistoryReportImageState({imageUrl: rootStore.emsStore.getHistoryReportImageState.imageUrl, showImage: false});
};

const onSearch = (filterTxt: string) => {
  setCurrentPage(1);
  let filteredMedicalEmergenciesWithPassenger =
    rootStore.emsStore.medicalEmergencyWithPassengerList.filter((item) => {
      const selectedDateMs = new Date(
        Date.parse(rootStore.emsStore.getSelectedDate)
      );
      const medicalEmergencyDateMs = new Date(Date.parse(item.timestamp));
      selectedDateMs.setHours(0, 0, 0, 0);
      medicalEmergencyDateMs.setHours(0, 0, 0, 0);
      if (item?.passenger?.name !== null) {
        if (rootStore.emsStore.getIsDateSelected) {
          let r =  selectedDateMs.getTime() === medicalEmergencyDateMs.getTime() 
          && 
          (
            item?.passengerName.toLocaleLowerCase().includes(filterTxt.toLocaleLowerCase()) 
            || 
            item.id.toString().toLocaleLowerCase().includes(filterTxt.toLocaleLowerCase())
            ||
            item.flightId.toString().toLocaleLowerCase().includes(filterTxt.toLocaleLowerCase())
            ||
            item.createdBy.toLocaleLowerCase().includes(filterTxt.toLocaleLowerCase())
            ||
            item.assignedEms.toLocaleLowerCase().includes(filterTxt.toLocaleLowerCase())
            ||
            item.status.toLocaleLowerCase().includes(filterTxt.toLocaleLowerCase())
          )
          return r;
        } else {
          let r =  
          (
            item?.passengerName.toLocaleLowerCase().includes(filterTxt.toLocaleLowerCase()) 
            || 
            item.id.toString().toLocaleLowerCase().includes(filterTxt.toLocaleLowerCase())
            ||
            item.flightId.toString().toLocaleLowerCase().includes(filterTxt.toLocaleLowerCase())
            ||
            item.createdBy.toLocaleLowerCase().includes(filterTxt.toLocaleLowerCase())
            ||
            item.assignedEms.toLocaleLowerCase().includes(filterTxt.toLocaleLowerCase())
            ||
            item.status.toLocaleLowerCase().includes(filterTxt.toLocaleLowerCase())
          )
          return r;
        }
      }
    });
    setList(filteredMedicalEmergenciesWithPassenger);
}

const handleKeyDown = (e: any) => {
  if (searchString.length !== 0) {
    if (e.key === "Enter") {
      onSearch(searchString)
    }
  }
}
const handlePageChange = (page:any)=> {
  setCurrentPage(page);
};

const startIndex = (currentPage - 1) * itemsPerPage;
const endIndex = startIndex + itemsPerPage;
const visibleUsersList = list.slice(startIndex, endIndex);

  return (
    <div className="table_mail_container">
      {
        rootStore.emsStore.getReportModal
        ?
        <ReportModal />
        :
        null
      }
      <Box
        width={"100%"}
        style={{height: '100%'}}
        direction="row"
        justify="center"
        align="start"
      >
        <Box
          background={StandardColors.white}
          elevation="xsmall"
          fill={true}
          style={{
            borderRadius: 16,
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
            width: "70%",
          }}
        >
          <Text className="heading_text" textAlign="start">
            Medical Emergency History
          </Text>
          <div className="search_main">
           <CommonSearchInput
          //   style={{
          //   color: "#41454B",

          //   fontFamily: "Inter",
          //   fontSize: "14px",
          //   fontStyle: "normal",
          //   fontWeight: "500",
          //   lineHeight: "22px",
          //  }}
           placeholder = "Search by ID, Name, Flight ID"
           onkeydown={(e: any) => handleKeyDown(e)} onchange={(e:any) => onSearchStrChange(e.target.value)}/>
           <CommonButton
              title="Search"
              padding="10px 24px 10px 28px"
              color="#fff"
              bgColor="#357EFF"
              radius={10}
              border="1px solid #357EFF"
              lineheight="14px"
              ml={5}
              onclick={() => onSearch(searchString)}
            />
          </div>
          <Box style={{padding: 14}}>
            <MedicalEmergencyTable
              medicalEmergencyList={visibleUsersList}
            />

          </Box>
        {Math.ceil(list.length / itemsPerPage) > 1 && (
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(list.length / itemsPerPage)}
            totalItems={list.length}
            onPageChange={handlePageChange}
          />
        )}
        </Box>
        <Box
          pad={"small"}
          background={StandardColors.white}
          elevation="xsmall"
          align="center"
          justify="center"
          style={{
            borderRadius: 16,
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
            marginLeft: 12,
            width: "30%",
            position: 'relative'
          }}
          className="calendar-main"
        >
          {
            rootStore.emsStore.getYearSelection
            &&
            <YearSelection
              onYearSelected={onYearSelected}
              onMonthSelected={onMonthSelected}
              selectedYear={rootStore.emsStore.getSelectedYear}
            />
          }
          <Calendar
          className="calender calendar-customize"
            size="medium"
            date={rootStore.emsStore.getSelectedDate}
            onSelect={(date) => {
              Mixpanel.track("web_medical_history_date_select",{name: user?.username});
              rootStore.emsStore.setSelectedDate(date as string);
              rootStore.emsStore.handleIsDateSelect();
            }}
            animate={true}
            fill={true}
            daysOfWeek={true}
          />
        </Box>
      </Box>

      {rootStore.emsStore.getHistoryReportImageState.showImage && (
        <ImageViewer
          src={[rootStore.emsStore.getHistoryReportImageState.imageUrl]}
          currentIndex={0}
          onClose={closeImage}
          backgroundStyle={{
            zIndex: 10000,
            backgroundColor: "rgba(0,0,0,0.7)",
          }}
        />
      )}
    </div>
  );
});

export default MedicalEmergencyHistory;
